import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import MaterialSelect from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Divider from '@material-ui/core/Divider';
import FormFieldBase from './FieldBase';
/**@param {import('./types').FinalFormFieldSelectProps} props */

var FormSelect = function FormSelect(_ref) {
  var _ref$input = _ref.input,
      name = _ref$input.name,
      value = _ref$input.value,
      onChange = _ref$input.onChange,
      restInput = _objectWithoutProperties(_ref$input, ["name", "value", "onChange"]),
      meta = _ref.meta,
      label = _ref.label,
      formControlProps = _ref.formControlProps,
      options = _ref.options,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["input", "meta", "label", "formControlProps", "options", "children"]);

  var showError = (meta.submitError && !meta.dirtySinceLastSubmit || meta.error) && meta.touched;
  var menuItems = children || options.map(function (opt, idx) {
    if (opt === 'separator') return React.createElement(Divider, {
      key: idx
    });
    return React.createElement(MenuItem, {
      key: idx,
      value: opt.value
    }, opt.label || opt.value);
  });
  return React.createElement(FormControl, Object.assign({}, formControlProps, {
    error: showError
  }), !!label && React.createElement(InputLabel, {
    htmlFor: name
  }, label), React.createElement(MaterialSelect, Object.assign({}, rest, {
    name: name,
    onChange: onChange,
    inputProps: restInput,
    value: value
  }), menuItems), showError && React.createElement(FormHelperText, null, meta.error || meta.submitError));
};

export var Select = function Select(_ref2) {
  var name = _ref2.name,
      rest = _objectWithoutProperties(_ref2, ["name"]);

  return React.createElement(FormFieldBase, Object.assign({
    name: name,
    label: name
  }, rest));
};
Select.defaultProps = {
  component: FormSelect,
  onChange: function onChange(f) {
    return f;
  },
  margin: 'normal',
  fullWidth: true
};
export default FormSelect;